import styled from 'styled-components';
import { fonts } from 'theme';

export const StyledContent = styled.div`
margin: 0.2em 0.5em;
width: inherit;
word-break: break-word;
font-size: ${fonts.size.f7};
display: inline-flex;
justify-content: space-between;
align-items: center;
`;
